var map = {
	"./symbol_0.png": "25fa",
	"./symbol_1.png": "4806",
	"./symbol_2.png": "0869",
	"./symbol_3.png": "95b1",
	"./symbol_4.png": "cdcc",
	"./symbol_5.png": "f26a",
	"./symbol_6.png": "f026",
	"./symbol_7.png": "9a46",
	"./symbol_8.png": "38c3",
	"./symbol_9.png": "89df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d3c2";